import { all } from 'redux-saga/effects';

import { testSaga } from './modules/test/saga';
import { createEmployeeSaga } from './modules/users/store/saga/index';
import { createPaymentsSaga } from './modules/payments/store/saga/index';
import { createIMCSaga } from './modules/imc/store/saga/index';
import { createBankDetailsSaga } from './modules/bankdetails/SuperAdmin/store/saga/index';
import { createGenInfoSaveSaga } from './modules/checkListGenerator/store/saga/index';

function* rootSaga() {
    yield all([testSaga(), createEmployeeSaga(), createPaymentsSaga(), createIMCSaga(), createBankDetailsSaga(), createGenInfoSaveSaga()]);
}

export default rootSaga;
